var _defs, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectionBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#007cf7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003e7c",
    stopOpacity: 0.631
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "circle_background",
    "data-name": "circle background",
    width: 68,
    height: 68,
    rx: 34,
    fill: "url(#radial-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectionBackground);
export default __webpack_public_path__ + "static/media/selection-background.2bb5275d47cc95ab963a883eee303b2e.svg";
export { ForwardRef as ReactComponent };